export default searchText => ({ name_contains: searchText })
